import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'primary' | 'secondary';
  onClick?: () => void;
}
export const CTAButton: React.FC<CTAButtonProps> = ({
  text = 'Sí, quiero el MegaPack Ciencias Naturales ahora',
  className = '',
  fullWidth = false,
  variant = 'primary',
  onClick
}) => {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('compra');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
    if (onClick) onClick();
  };
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1';
  const variants = {
    primary: 'bg-amber-500 hover:bg-amber-400 text-white border-b-4 border-amber-700 hover:border-amber-600',
    secondary: 'bg-green-700 hover:bg-green-600 text-white border-b-4 border-green-900 hover:border-green-800'
  };
  return <motion.button whileTap={{
    scale: 0.98,
    y: 0
  }} onClick={scrollToPricing} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full py-4 text-xl' : 'px-8 py-3 text-lg'} ${className}`} data-id="element-40">
      <span className="mr-2" data-id="element-41">{text}</span>
      <ArrowRight className="w-5 h-5" data-id="element-42" />
    </motion.button>;
};